
import {Component, Vue} from 'vue-property-decorator';
import CompanyService from '@/services/CompanyService';
import {NotificationTypes, notify, resolveError} from '@/utils/notifications';
import {i18n} from '@/plugins/i18n';

@Component({
  name: 'OAuth',
})

export default class OAuth extends Vue {

  private nextStep: any = 1;

  private apiType = '';
  private loading: boolean = false;

  async navigate() {
    if (this.nextStep === 4){
      await this.$router.push({name: 'CompanyConfig.vue'});
    } else {
      let step;
      switch (this.apiType) {
        case 'spapi':
          step = 2;
          break;
      }
      // @ts-ignore
      await this.$router.push({name: 'Configuration', query: {step: step}});
    }
  }

  mounted() {
    this.apiType = this.$route.params.apiType;

    switch (this.apiType) {
      case 'spapi':
        this.performSPAPI()
        break;
    }
  }

  async performSPAPI() {
    if (!!this.QueryParams.selling_partner_id && !!this.QueryParams.spapi_oauth_code) {
      const api = {
        sellingPartnerId: this.QueryParams.selling_partner_id,
        mwsAuthToken: this.QueryParams.mws_auth_token,
        spApiOauthCode: this.QueryParams.spapi_oauth_code,
      }

      // @ts-ignore
      await this.$router.replace({'query': null});
      await this.exchangeSPAPI(api);
    }
  }

  async exchangeSPAPI(api: any) {
    try {
      this.loading = true;
      await CompanyService.exchangeSPAPI(api);
      notify(
          NotificationTypes.success,
          i18n.t('SYSTEM_CONFIGURATION_AUTHORIZED'),
      );
      setTimeout(() => this.navigate(), 2000);
    } catch (e) {
      resolveError(e, 'fetch_data');
    } finally {
      this.loading = false;
    }
  }

  get QueryParams() {
    return this.$route.query;
  }

}

